import { render, staticRenderFns } from "./CatRatePopupManager.vue?vue&type=template&id=65a4d1da&"
import script from "./CatRatePopupManager.vue?vue&type=script&lang=js&"
export * from "./CatRatePopupManager.vue?vue&type=script&lang=js&"
import style0 from "./CatRatePopupManager.vue?vue&type=style&index=0&id=65a4d1da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports